import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MORE_OPTIONS_SELECTOR, allOption, bikeOption, busOption, walkOption } from './constants';
import { TranslocoPipe } from '@ngneat/transloco';
import { RouteFormMoreOptionsService } from './services/route-form-more-options.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BicycleFormComponent } from '@shared/components';
import { BusFormComponent } from '@shared/components/bus-form/bus-form.component';
import { WalkFormComponent } from '@shared/components/walk-form/walk-form.component';

@Component({
  selector: 'app-route-form-more-options',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, MatIconModule, MatButtonModule, MatButtonToggleModule, MatInputModule, FormsModule,
            BusFormComponent, BicycleFormComponent, WalkFormComponent],
  templateUrl: './route-form-more-options.component.html',
  styleUrls: ['./route-form-more-options.component.scss']
})
export class RouteFormMoreOptionsComponent {

  public moreOptionsSelector = MORE_OPTIONS_SELECTOR;
  public routeFormService = inject(RouteFormMoreOptionsService);
  public optionSelected = this.routeFormService.moreOptionsSelected;

  public busId = busOption.id;
  public walkId = walkOption.id;
  public bicycleId = bikeOption.id;
  public allId = allOption.id;

  public fast = this.routeFormService.fast;
  public flat = this.routeFormService.flat;
  public bicycleAdapted = this.routeFormService.bicycleAdapted;
  public resetObservable = this.routeFormService.resetObservable;

  public itineraryType = this.routeFormService.itineraryType;
  public maxWalkTimeOnBusItinerary = this.routeFormService.maxWalkTimeOnBusItinerary;
  public walkSpeed = this.routeFormService.walkSpeed;
  public bikeSpeed = this.routeFormService.bikeSpeed;

  public maxWalkTime = this.routeFormService.maxWalkTime;
  public wheelcharAccessible = this.routeFormService.wheelcharAccessible;

  public maxWalkTimeOnMultimodal = this.routeFormService.maxWalkTimeOnMultimodal;

}
